import React, { useState } from 'react';
import { Link } from 'react-router';
import { ListItemText, Menu, MenuItem, ListItemIcon, AppBar, Tab, Tabs, Stack, IconButton } from '@mui/material';
import { CalendarMonth, Settings, Email, Web, Insights, Topic, Poll } from '@mui/icons-material';
import ReportingPeriod from '../account/reportingPeriod/ReportingPeriod';
import FullScreenSettingsDialog from '../shared/FullScreenSettingsDialog';
import DatesSelector from './DatesSelector';
import Topics from '../account/topics/Topics';
import TopicFilter from '../topics/TopicFilter';

const SettingsMenu = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [selectedMenuItem, setSelectedMenuItem] = useState(null);
    const open = Boolean(anchorEl);

    const handleDialogOpen = (menuItem) => {
        setIsDialogOpen(true);
        setSelectedMenuItem(menuItem);
        setAnchorEl(null);
    };

    const handleDialogClose = () => {
        setIsDialogOpen(false);
        setAnchorEl(null);
        setSelectedMenuItem(null);
    };

    const menuItems = {
        managePeriod: { label: 'Reporting Period', icon: <CalendarMonth fontSize="small" />, component: <ReportingPeriod onClose={handleDialogClose} /> },
        manageTopics: { label: 'Manage Topics', icon: <Topic fontSize="small" />, component: <Topics /> }
    };

    return (
        <>
            <IconButton
                onClick={(event) => setAnchorEl(event.currentTarget)}
                variant="text"
            >
                <Settings />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
            >
                {Object.keys(menuItems).map((menuItem) => (
                    <MenuItem
                        key={menuItem}
                        onClick={() => handleDialogOpen(menuItem)}
                    >
                        <ListItemIcon>
                            {menuItems[menuItem].icon}
                        </ListItemIcon>
                        <ListItemText>{menuItems[menuItem].label}</ListItemText>
                    </MenuItem>
                ))}
            </Menu>
            {isDialogOpen && (
                <FullScreenSettingsDialog
                    handleDialogClose={handleDialogClose}
                    title={menuItems[selectedMenuItem]?.label}
                >
                    {menuItems[selectedMenuItem]?.component}
                </FullScreenSettingsDialog>
            )}
        </>
    );
};

const TitleBar = ({ reportingPeriods, selectedPeriods, onSetCompare, onSetSelectedPeriods, compare, periodColours, tab, location, titleBarHeight, topics, filterTopics, onChangeTopicsFilter }) => {
    const isItem = Boolean(location.pathname.match('\\d'));

    return (
        <AppBar
            position="sticky"
            color="inherit"
            elevation={tab === '' ? 4 : 0}
            sx={{
                top: 64,
                display: 'flex',
                flexDirection: 'row'
            }}
        >
            <Tabs value={tab}>
                <Tab
                    component={Link}
                    to="/newreports"
                    icon={<Insights />}
                    iconPosition="start"
                    label="Overview"
                    value=""
                    sx={{
                        minHeight: titleBarHeight
                    }}
                />
                <Tab
                    component={Link}
                    to="/newreports/emails"
                    icon={<Email />}
                    iconPosition="start"
                    label="Emails"
                    value="emails"
                    sx={{
                        minHeight: titleBarHeight
                    }}
                />
                <Tab
                    component={Link}
                    to="/newreports/pages"
                    icon={<Web />}
                    iconPosition="start"
                    label="Landing Pages"
                    value="pages"
                    sx={{
                        minHeight: titleBarHeight
                    }}
                />
                <Tab
                    component={Link}
                    to="/newreports/surveys"
                    icon={<Poll />}
                    iconPosition="start"
                    label="Surveys"
                    value="surveys"
                    sx={{
                        minHeight: titleBarHeight
                    }}
                />
            </Tabs>
            {!isItem && (
                <Stack
                    direction="row"
                    spacing={1}
                    sx={{
                        flexGrow: 1,
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        pr: 1
                    }}
                >
                    <TopicFilter
                        availableTopics={topics}
                        selectedTopics={filterTopics}
                        onAddTopic={topic => onChangeTopicsFilter(topic)}
                        onRemoveTopic={topic => onChangeTopicsFilter(topic)}
                        onClearTopics={() => onChangeTopicsFilter()}
                    />
                    <DatesSelector
                        reportingPeriods={reportingPeriods}
                        selectedPeriods={selectedPeriods}
                        onSetSelectedPeriods={onSetSelectedPeriods}
                        compare={compare}
                        onSetCompare={onSetCompare}
                        periodColours={periodColours}
                    />
                    <SettingsMenu />
                </Stack>
            )}
        </AppBar>
    );
};

export default TitleBar;